import httpService from './httpService';
import { setToken, signOut } from '../apps/auth/action-creators';

export default function JWTMiddleware() {
  return ({ dispatch, getState }) => (next) => (action) => {
    const { token } = getState().auth;
    if ((typeof action !== 'function') || !token || !token.refreshToken) return next(action);

    const refreshThreshold = new Date().getTime();
    if (refreshThreshold >= token.expiredAt) {
      const http = httpService;
      return http.post('/api/v1/user/token/update/', { refresh_token: token.refreshToken }, { NO_AUTH: true }).then(
        (response) => {
          const { accessToken, refreshToken } = response;
          const expiredAt = new Date().getTime() + 300000;
          dispatch(setToken(accessToken, refreshToken, expiredAt));
          return next(action);
        },
        () => {
          dispatch(signOut());
          return next(action);
        },
      );
    }

    return next(action);
  };
}
